// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

// Internal Dependencies
import connectComponent from '../connect-component';
import CoderCard from './CoderCard';
import styles from '../styles/Styles';

// Local variables
const thisStyle = styles.coderList;

// Component definition
class CoderList extends Component {
  static propTypes = {
    badges: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    coders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      searchString: '',
    };
  }

  updateSearch(event) {
    this.setState({
      searchString: event.target.value.substr(0, 20).toLowerCase(),
    });
  }

  render() {
    const {
      badges,
      coders,
    } = this.props;

    if (!coders) return null;

    let codersArray = [];
    codersArray = Object.keys(coders).map(key => coders[key]);

    // Order coders by most recent coder dojo attended
    codersArray.sort((objA, objB) => {
      const attendanceKeyA = Object.keys(objA.attendance).pop();
      const attendanceKeyB = Object.keys(objB.attendance).pop();
      const dateA = new Date(objA.attendance[attendanceKeyA]);
      const dateB = new Date(objB.attendance[attendanceKeyB]);
      if (dateA.getTime() < dateB.getTime()) {
        return 1;
      }
      if (dateA.getTime() > dateB.getTime()) {
        return -1;
      }
      return 0;
    });

    const filteredCoders = Object.keys(codersArray).filter((key) => {
      const name = `${codersArray[key].firstName} ${codersArray[key].lastName}`;
      return name.toLowerCase().indexOf(this.state.searchString) !== -1;
    })
    .map(key => codersArray[key],
    );

    return (
      <div>
        <div style={thisStyle.searchSection}>
          <TextField
            hintStyle={thisStyle.hintStyle}
            hintText={<div>&nbsp;🔎 &nbsp;&nbsp;&nbsp;Search by name</div>}
            inputStyle={thisStyle.inputStyle}
            onChange={event => this.updateSearch(event)}
            style={thisStyle.searchTextBox}
          />
        </div>
        <br />
        <div style={thisStyle.coderListSection}>
          {
            Object.keys(filteredCoders).map((key, index) => (
              <CoderCard
                badges={badges}
                coder={filteredCoders[index]}
                details={false}
                index={filteredCoders[index].key}
                key={`${filteredCoders[index].firstName}-${filteredCoders[index].lastName}`}
              />
            ))
          }
        </div>
      </div>
    );
  }
}

export default connectComponent(state => ({
  badges: state.badges,
  coders: state.coders,
}), {
}, CoderList);



/** WEBPACK FOOTER **
 ** ./src/ninjas/CoderList.js
 **/